import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface BrandSettings {
  symbolDark: string | null;
  symbolLight: string | null;
  logoTextDark: string | null;
  logoTextLight: string | null;
  platformName: string;
  platformTagline: string;
}

const DEFAULT_BRAND_SETTINGS: BrandSettings = {
  symbolDark: null,
  symbolLight: null,
  logoTextDark: null,
  logoTextLight: null,
  platformName: 'AutoFLUXO',
  platformTagline: 'Sistema de Gestão Automotiva',
};

export const useBrandSettings = () => {
  return useQuery({
    queryKey: ['public-brand-settings'],
    queryFn: async (): Promise<BrandSettings> => {
      const { data, error } = await supabase.rpc('get_public_brand_settings');
      
      if (error) {
        console.warn('Erro ao buscar brand settings:', error);
        return DEFAULT_BRAND_SETTINGS;
      }
      
      // Converter array de {key, value} para objeto
      const settingsMap: Record<string, string> = {};
      (data || []).forEach((item: { key: string; value: string }) => {
        // value vem como jsonb, pode ser string ou objeto
        settingsMap[item.key] = typeof item.value === 'string' 
          ? item.value 
          : JSON.stringify(item.value);
      });
      
      return {
        symbolDark: settingsMap['brand_symbol_dark'] || null,
        symbolLight: settingsMap['brand_symbol_light'] || null,
        logoTextDark: settingsMap['brand_logo_text_dark'] || null,
        logoTextLight: settingsMap['brand_logo_text_light'] || null,
        platformName: settingsMap['platform_name'] || DEFAULT_BRAND_SETTINGS.platformName,
        platformTagline: settingsMap['platform_tagline'] || DEFAULT_BRAND_SETTINGS.platformTagline,
      };
    },
    staleTime: 5 * 60 * 1000, // Cache por 5 minutos
    gcTime: 10 * 60 * 1000, // Manter em cache por 10 minutos
    retry: 1,
    refetchOnWindowFocus: false,
  });
};

export default useBrandSettings;
